import { FormattedMessage, useIntl } from 'react-intl';

import SourceLogo from '@/assets/icons/source-logo.svg';
import { SourceUpgradeCard } from '@/components/ui/source-upgrade-card';
import { usePostHog } from '@/hooks/use-posthog';

/**
 * Sits above the locked openings and tells a free-tier account what they are
 * looking at.
 */
export function WelcomeBanner() {
  const intl = useIntl();
  const posthog = usePostHog();

  const benefits = [
    intl.formatMessage({
      defaultMessage: 'Compare every opening side by side',
      description:
        'Benefit of a Source subscription: hiring performance measures cover every opening at once',
    }),
    intl.formatMessage({
      defaultMessage: 'Spot the roles behind pace',
      description:
        'Benefit of a Source subscription: each job opening is measured on its own',
    }),
    intl.formatMessage({
      defaultMessage: 'Cue flags what to look at',
      description:
        'Benefit of a Source subscription: all job openings are listed together in a single table',
    }),
  ];

  return (
    <SourceUpgradeCard
      icon={<img src={SourceLogo} alt="" className="size-12 rounded-lg" />}
      title={
        <FormattedMessage
          defaultMessage="See performance by opening, not just by campaign"
          description="Headline of the banner above the locked sourcing dashboard, shown to accounts without a Source subscription"
        />
      }
      description={
        <FormattedMessage
          defaultMessage="Campaigns show one buy at a time. Openings roll them up by role — hires, spend, cost per hire — so you can see which roles are behind pace."
          description="Body of the banner above the locked sourcing dashboard, shown to accounts without a Source subscription; Source is the product name"
        />
      }
      benefits={benefits}
      ctaLabel={
        <FormattedMessage
          defaultMessage="All about Source"
          description="Button that opens the Source product page in a new tab, from the banner above the locked sourcing dashboard"
        />
      }
      onCtaClick={() =>
        posthog.capture('source_dashboard:all_about_source_button_click')
      }
    />
  );
}
